/* eslint-disable */
import AuthStore from 'auth-store';
import history from 'setup/history';
import { req } from 'react-reqq-lite';
import { closeModal } from 'partial/components/Modal';
import jwt_decode from 'jwt-decode';
import { fromPairs } from 'lodash';
import service from 'service';
import * as c from './constants';

export const login = (payload, onSuccess, onError, openMfa, setupMfa) => {
  req.post({
    key: c.LOGIN,
    url: '/core-auth/login',
    payload,
    onSuccess: (res) => {
      const cb = () => {
        const token = res?.response?.data?.token;
        const decoded = jwt_decode(token);
        const { scope } = decoded;
        const permissionsRaw = scope?.split(' ');
        const permissions = fromPairs(permissionsRaw?.map((x) => x.split(':')));
        AuthStore.set('_token', token);
        AuthStore.set('_permissions', JSON.stringify(permissions));
        req.set(c.AUTHENTICATION, {
          isAuthenticated: true,
          userType: 'ADMINISTRATOR',
        });
        if (typeof onSuccess === 'function') onSuccess(res);
        history.push('/dashboard');
      };
      const is_mfa_enabled = res.response?.data?.is_mfa_enabled;
      if (is_mfa_enabled) {
        openMfa();
        return;
      }
      if (!is_mfa_enabled) {
        const token = res?.response?.data?.token;
        AuthStore.set('_token', token);
        setupMfa(cb);
      }
    },
    onError,
  });
};

export const getProfile = (setter) => {
  req.get({
    key: c.PROFILE,
    url: '/acl/me/user',
    onSuccess: (res) => {
      const profile = res?.response?.data;
      setter(profile);
    },
  });
};

export const logout = () => {
  AuthStore.remove('_token');
  AuthStore.remove('_profile');
  AuthStore.remove('_permissions');
  closeModal();
  req.reset();
  req.set(c.AUTHENTICATION, {
    isAuthenticated: false,
    userType: null,
  });
};

export const verifyMfaOtp = (payload) => {
  const url = '/core-auth/verify_otp';
  return service.post(url, payload);
};

export const getQR = () => {
  const url = '/auth/v1/mfa/qr';
  return service.get(url);
};

export const mfaSetup = ({ type, ...rest }) => {
  const url = `/auth/v1/mfa/${type}`;
  return service.post(url, rest);
};
